// src/components/PermissionManager.jsx
import React, { useState } from 'react';
import { updateUserPermissions } from '../services/userManagementService';
import {
    PERMISSION_CATEGORIES,
    PERMISSION_LABELS
} from '../types/permissions';
import '../styles/components/PermissionManager.scss';

const PermissionManager = ({ user, accountId, onClose, onPermissionUpdated }) => {
    const [selectedPermissions, setSelectedPermissions] = useState(user.permissions || []);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handlePermissionChange = (permission, checked) => {
        if (checked) {
            setSelectedPermissions([...selectedPermissions, permission]);
        } else {
            setSelectedPermissions(selectedPermissions.filter(p => p !== permission));
        }
    };

    const handleSelectAllCategory = (categoryPermissions, checked) => {
        if (checked) {
            // カテゴリのすべての権限を追加
            const newPermissions = [...selectedPermissions];
            categoryPermissions.forEach(permission => {
                if (!newPermissions.includes(permission)) {
                    newPermissions.push(permission);
                }
            });
            setSelectedPermissions(newPermissions);
        } else {
            // カテゴリのすべての権限を削除
            setSelectedPermissions(
                selectedPermissions.filter(p => !categoryPermissions.includes(p))
            );
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);
            setMessage('');

            await updateUserPermissions(accountId, user.id, selectedPermissions);

            setMessage('権限を更新しました');
            setTimeout(() => {
                onPermissionUpdated();
            }, 1000);
        } catch (error) {
            setMessage('権限の更新に失敗しました: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="permission-manager-overlay">
            <div className="permission-manager">
                <div className="modal-header">
                    <h2>{user.displayName || user.email} の権限設定</h2>
                    <button className="close-button" onClick={onClose}>×</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="permissions-container">
                        {Object.entries(PERMISSION_CATEGORIES).map(([categoryKey, category]) => {
                            const categoryPermissions = category.permissions;
                            const allSelected = categoryPermissions.every(p => selectedPermissions.includes(p));
                            const someSelected = categoryPermissions.some(p => selectedPermissions.includes(p));

                            return (
                                <div key={categoryKey} className="permission-category">
                                    <div className="category-header">
                                        <label className="category-checkbox">
                                            <input
                                                type="checkbox"
                                                checked={allSelected}
                                                ref={input => {
                                                    if (input) input.indeterminate = someSelected && !allSelected;
                                                }}
                                                onChange={(e) => handleSelectAllCategory(categoryPermissions, e.target.checked)}
                                            />
                                            <span className="category-name">{category.name}</span>
                                        </label>
                                    </div>

                                    <div className="category-permissions">
                                        {categoryPermissions.map(permission => (
                                            <label key={permission} className="permission-checkbox">
                                                <input
                                                    type="checkbox"
                                                    checked={selectedPermissions.includes(permission)}
                                                    onChange={(e) => handlePermissionChange(permission, e.target.checked)}
                                                />
                                                <span>{PERMISSION_LABELS[permission]}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <div className="modal-actions">
                        <button type="button" className="btn-secondary" onClick={onClose}>
                            キャンセル
                        </button>
                        <button type="submit" className="btn-primary" disabled={loading}>
                            {loading ? '更新中...' : '権限を更新'}
                        </button>
                    </div>
                </form>

                {message && (
                    <div className={`message ${message.includes('失敗') ? 'error' : 'success'}`}>
                        {message}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PermissionManager;




